import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { VagaType } from './VagasIndex';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import axios_instance from '../../../services/auth/jwt/config';
import sweetAlert from '../../../f5/utils/sweetAlert';

interface DialogVagaFormProps {
    open: boolean;
    onClose: (reload?: boolean) => void;
    data: VagaType,
    onChange: (field: string, value: any) => void;
    mode: 'create' | 'edit' | 'show';
    modo: string, local: string,
}

export default function DialogVagaForm({ open, onClose, data, onChange, mode, modo, local, ...props }: DialogVagaFormProps) {
    const [naoInformado, setNaoInformado] = useState(false)
    const [loading, setLoading] = useState({ is: false, message: '' })

    const onSave = () => {
        setLoading({ is: true, message: 'Salvando...' })
        let link = `empregos/${modo}/${local}/vagasimples/new`
        if (mode === 'edit') {
            link = `empregos/${modo}/${local}/vagasimples/edit/${data.id}`
        }
        axios_instance.post<{ success: boolean, message: string }>(link, data).then((response) => {
            let res = response.data
            if (res.success) {
                sweetAlert('success', 'Sucesso', res?.message ?? 'Vaga salva com sucesso!', () => {
                    onClose(true)
                })
            } else {
                sweetAlert('error', 'Erro', res?.message ?? 'Erro ao salvar vaga.')
            }
        }).catch(() => {
            sweetAlert('error', 'Erro', 'Erro ao salvar vaga!')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }

    return <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="xl" style={{ zIndex: 1103 }}>
        <Backdrop open={loading.is} style={{ zIndex: 1105 }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%" color="white">
                <CircularProgress />
                <Typography variant="h6" style={{ marginLeft: 10 }}>{loading.message}</Typography>
            </Box>
        </Backdrop>
        <DialogTitle>
            {mode === 'create' && 'Criar Vaga'}
            {mode === 'edit' && 'Editar Vaga'}
            {mode === 'show' && 'Visualizar Vaga'}
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        label="Nome da Vaga"
                        variant="outlined"
                        fullWidth
                        value={data.titulo}
                        disabled={mode === 'show'}
                        onChange={(e) => onChange('titulo', e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        label="Código"
                        variant="outlined"
                        fullWidth
                        value={data.codigo}
                        disabled={mode === 'show'}
                        onChange={(e) => onChange('codigo', e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <KeyboardDatePicker
                        label="Data de Limite"
                        inputVariant='outlined'
                        format="DD/MM/YYYY"
                        value={moment(data.limite, 'YYYY-MM-DD')}
                        disabled={mode === 'show'}
                        onChange={(date) => onChange('limite', date?.format('YYYY-MM-DD'))}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Descrição"
                        variant="outlined"
                        fullWidth
                        multiline
                        minRows={4}
                        value={data.descricao}
                        disabled={mode === 'show'}
                        onChange={(e) => onChange('descricao', e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Número de Vagas"
                        variant="outlined"
                        fullWidth
                        value={data.vagas}
                        disabled={mode === 'show'}
                        onChange={(e) => onChange('vagas', e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Empresa"
                        variant="outlined"
                        fullWidth
                        value={data.empresa}
                        disabled={!!data?.confidencial || mode === 'show'}
                        onChange={(e) => onChange('empresa', e.target.value)}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Confidencial"
                        checked={!!data?.confidencial}
                        disabled={mode === 'show'}
                        //@ts-ignore
                        onChange={(e) => onChange('confidencial', e.target.checked ? 1 : 0)}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl
                        disabled={mode === 'show'}
                        fullWidth
                    >
                        <FormLabel component="legend">Sexo</FormLabel>
                        <RadioGroup value={data.sexo} onChange={e => { onChange('sexo', e.target.value) }} row>
                            {['Masculino', 'Feminino', 'Ambos'].map((option) => {
                                return <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
                            })}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        label="Salário"
                        variant="outlined"
                        fullWidth

                        value={data.salario}
                        onChange={(e) => onChange('salario', e.target.value)}
                        disabled={naoInformado || mode === 'show'}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Não Informado"
                        checked={naoInformado}
                        disabled={mode === 'show'}
                        onChange={(e) => {
                            //@ts-ignore
                            setNaoInformado(e.target.checked)
                            //@ts-ignore
                            onChange('salario', e.target.checked ? '' : data.salario)
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl
                        fullWidth
                        disabled={mode === 'show'}
                        variant="outlined"
                    >
                        <InputLabel>Escolaridade</InputLabel>
                        <Select
                            value={data?.escolaridade}
                            onChange={e => { onChange('escolaridade', e.target.value) }}
                            label="Escolaridade"
                        >
                            {[
                                { value: '', label: 'N/A' },
                                { value: 'Ensino Médio Incompleto', label: 'Ensino Médio Incompleto' },
                                { value: 'Ensino Médio Completo', label: 'Ensino Médio Completo' },
                                { value: 'Ensino Superior Incompleto', label: 'Ensino Superior Incompleto' },
                                { value: 'Ensino Superior Completo', label: 'Ensino Superior Completo' },
                                { value: 'Mestrado Incompleto', label: 'Mestrado Incompleto' },
                                { value: 'Mestrado Completo', label: 'Mestrado Completo' },
                                { value: 'Doutorado Incompleto', label: 'Doutorado Incompleto' },
                                { value: 'Doutorado Completo', label: 'Doutorado Completo' },
                                { value: 'Pós-Doutorado', label: 'Pós-Doutorado' },
                            ].map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl
                        fullWidth
                        disabled={mode === 'show'}
                    >
                        <FormLabel>Carga Horária</FormLabel>
                        <RadioGroup
                            value={data.carga_horaria}
                            onChange={(e) => onChange('carga_horaria', e.target.value)}
                            row
                        >
                            {['Tempo Integral', 'Meio Período', 'A combinar'].map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl
                        fullWidth
                        disabled={mode === 'show'}
                    >
                        <FormLabel>Experiência</FormLabel>
                        <RadioGroup
                            value={data.exp}
                            onChange={(e) => onChange('exp', e.target.value)}
                            row
                        >
                            {['Sim', 'Não'].map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        label="Experiência (Meses)"
                        variant="outlined"
                        fullWidth
                        value={data.exptime}
                        onChange={(e) => onChange('exptime', e.target.value)}
                        disabled={data.exp !== 'Sim' || mode === 'show'}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Observações"
                        variant="outlined"
                        fullWidth
                        multiline
                        minRows={2}
                        value={data.obs}
                        disabled={mode === 'show'}
                        onChange={(e) => onChange('obs', e.target.value)}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Box display="flex" justifyContent="space-between" width="100%">
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => onClose()}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={mode === 'show'}
                    onClick={onSave}
                >
                    Salvar
                </Button>
            </Box>
        </DialogActions>
    </Dialog >
}